export const appendLangCode = (url: string, langCode: string): string => {
  const urlObj = new URL(url);
  urlObj.searchParams.set('langCode', langCode);
  return urlObj.toString();
};
